import tw from "twin.macro";

export const ButtonWrapper = tw.div`tw-flex`;
